/**
 * Normalizes a string for case- and accent-insensitive matching: lower-cases
 * and strips combining diacritical marks so e.g. "Béres" -> "beres" and
 * "Győr" -> "gyor". Useful for client-side filtering of Hungarian names.
 */
export function normalizeForSearch(value: string | undefined | null): string {
  const decomposed = (value ?? '').toLowerCase().normalize('NFD');
  let result = '';
  for (const ch of decomposed) {
    const code = ch.codePointAt(0) ?? 0;
    // Skip Unicode combining diacritical marks (U+0300..U+036F).
    if (code < 0x300 || code > 0x36f) {
      result += ch;
    }
  }
  return result;
}
